module.exports = __webpack_public_path__ + "static/media/less-than.b2655e5b.svg";